function NewSecondaryButton({ children, onClick }) {
    return (
        <button
            onClick={onClick}
            className="text-xl w-full shadow-lg p-[2px] rounded olm-gradient hover:bg-none hover:bg-secondary text-white font-semibold text-center">
            <span className="flex justify-center items-center bg-white px-8 py-4 md:py-[22px] hover:bg-secondary hover:text-white rounded text-secondary">
                {children}
            </span>
        </button>
    )
}

export default NewSecondaryButton
